import React, { useState, useEffect, useRef } from "react";

const DaysDropdown = ({ selectedDays, onChange, isSecAdmin, theme = 'light' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                disabled ={isSecAdmin}
                className={`p-2 border-2 rounded-lg w-full text-left focus:border-blue-500 focus:outline-none transition-colors ${
                    theme === 'dark' 
                        ? 'bg-gray-700 border-gray-600 text-white' 
                        : 'bg-white border-gray-300 text-gray-900'
                }`}
            >
                {selectedDays.length ? selectedDays.join(', ') : 'Select Days'}
            </button>
            {isOpen && (
                <div className={`absolute z-[9999] bottom-full mb-1 w-full border rounded shadow-lg max-h-60 overflow-y-auto ${
                    theme === 'dark'
                        ? 'bg-gray-700 border-gray-600'
                        : 'bg-white border-gray-300'
                }`}>
                    {days.map(day => (
                        <label key={day} className={`flex items-center p-2 cursor-pointer ${
                            theme === 'dark'
                                ? 'hover:bg-gray-600 text-white'
                                : 'hover:bg-gray-100 text-gray-900'
                        }`}>
                            <input
                                type="checkbox"
                                value={day}
                                checked={selectedDays.includes(day)}
                                onChange={() => {
                                    const newSelectedDays = selectedDays.includes(day)
                                        ? selectedDays.filter(d => d !== day)
                                        : [...selectedDays, day];
                                    onChange(newSelectedDays);
                                }}
                                className="mr-2"
                            />
                            <span>{day}</span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DaysDropdown;
